import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export function ProfitGauge({ profit, income, expenses }) {
  const fmt = (a) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(a || 0);
  const inc = income?.total_paid || 0;
  const exp = expenses?.monthly_total || 0;
  const margin = profit.margin_percent || 0;
  const isPositive = profit.monthly >= 0;

  const donutData = [
    { name: 'Expenses', value: exp || 1 },
    { name: 'Income', value: inc || 1 },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 text-center">
      <h3 className="font-bold text-[#0A1628] mb-1">Profit</h3>
      <p className={`text-3xl font-bold ${isPositive ? 'text-green-600' : 'text-red-500'}`}>{margin}%</p>
      <div className="relative mx-auto" style={{ width: 180, height: 180 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={donutData} cx="50%" cy="50%" innerRadius={55} outerRadius={80} paddingAngle={2} dataKey="value" startAngle={90} endAngle={-270}>
              <Cell fill="#ef4444" />
              <Cell fill="#22c55e" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`text-2xl font-bold ${isPositive ? 'text-green-600' : 'text-red-500'}`}>{fmt(profit.monthly)}</span>
          <span className="text-[10px] text-gray-400">Net</span>
        </div>
      </div>
      <div className="flex justify-center gap-4 mt-2 text-xs">
        <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 bg-red-500 rounded-full" /> Expense</span>
        <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 bg-green-500 rounded-full" /> Income</span>
      </div>
    </div>
  );
}
